import { STATUS_PRINT } from 'navigation/CONSTANTS';
import { navigateTo } from 'utils/JTUtils';
import {
    PRINT_ACCOUNT_KEY,
    PRINT_DELIVERY_ID_KEY,
    PRINT_DISPLAY_CD_KEY,
    PRINT_VENDOR_ID_KEY,
    PRINT_SHOW_BIGGER_KEY,
} from 'utils/storage/CONSTANTS';
import { setLocalStorage } from 'utils/storage/LocalStorageHelper';

export const qtyHeader = (isDelivered) => {
    return isDelivered ? 'Delivered' : 'Ordered';
};
export const qtyValue = (line) => {
    return (line.qtyFinal ? line.qtyFinal : '0') + ' of ' + line.qtyTarget;
};
export const goToDeliveryPrint = ({
    deliveryId,
    account,
    vendorId,
    displayCd,
    history,
    newPage,
    showBigger,
}) => {
    if (deliveryId) {
        setLocalStorage(PRINT_DELIVERY_ID_KEY, deliveryId);
    }
    if (account) {
        setLocalStorage(PRINT_ACCOUNT_KEY, account);
    }
    if (vendorId) {
        setLocalStorage(PRINT_VENDOR_ID_KEY, vendorId);
    }
    if (displayCd) {
        setLocalStorage(PRINT_DISPLAY_CD_KEY, displayCd);
    }
    if (showBigger) {
        setLocalStorage(PRINT_SHOW_BIGGER_KEY, showBigger);
    }
    if (!newPage) {
        navigateTo(history, STATUS_PRINT);
    } else {
        window.open(STATUS_PRINT, '_blank');
    }
};
